import * as PIXI from "pixi.js";
import Game from "../Game";
import { Slider } from "@pixi/ui";
import Layers from "../layers/Layers";
import { BaseSliderProps, SliderColorStyle } from "../types/Interface";


export default class BaseSlider extends PIXI.Container {
  Slider: Slider;
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private isVertical: boolean = false;
  private sliderStyle: SliderColorStyle;
  private head: string;
  private subHead: string;
  private handleOnUpdate: (value: number) => void;
  private handleOnEnd: () => void;
  constructor(props: BaseSliderProps, handleOnEnd: () => void, handleOnUpdate: (value: number) => void) {
    super();
    Object.assign(this, props)
    this.getIsVertical();

    this.handleOnEnd = handleOnEnd;
    this.handleOnUpdate = handleOnUpdate;
    this.generateHead();
    props.subHead && this.generateSubHead();
    this.generateBg();
    this.addSlider();
    this.addHandleEvent();
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.UI.addChild(this);
  private getIsVertical() {
    const dim = this.Game.getDim();
    this.isVertical = dim.WIDTH < dim.HEIGHT;
  }
  private generateHead() {
    const head = new PIXI.Text({ text: this.head });
    head.style.fontWeight = "700";
    head.style.fontSize = this.isVertical ? 30 : 25;
    head.anchor.set(.5);
    head.x = this.isVertical ? 115 : 140;
    head.y = -90;
    this.addChild(head);
  }
  private generateSubHead() {
    const sub = new PIXI.Text({ text: this.subHead });
    sub.style.fontWeight = "500";
    sub.style.fontSize = 15;
    sub.anchor.set(.5);
    sub.x = this.isVertical ? 115 : 140;
    sub.y = -70;
    this.addChild(sub);
  }
  private generateBar(isTransparent: boolean = false) {
    const bar = new PIXI.Graphics();
    this.isVertical ? bar.roundRect(0, -10, 230, 20, 8) : bar.rect(0, -5, 280, 10);
    bar.fill({ color: this.sliderStyle.barColor, alpha: isTransparent ? 0 : .5 });
    return bar
  }
  private generateSliderButton() {
    const button = new PIXI.Graphics()
    this.isVertical ? button.circle(0, -10, 30) : button.rect(-15, -30, 30, 50);
    button.fill(this.sliderStyle.buttonColor)
    return button;
  }
  private generateBg() {
    const bg = new PIXI.Graphics()
    this.isVertical ? bg.roundRect(-25, -60, 280, 120, 30) : bg.roundRect(-25, -60, 330, 120, 25);
    bg.fill({ color: this.sliderStyle.bgColor, alpha: .2 })
      .stroke({ color: 0x000000, width: 3 })
    this.addChild(bg);
  }
  private addHandleEvent() {
    this.Slider.interactive = true;
    this.Slider.on("mouseup", () => this.handleOnEnd());
    this.Slider.on("touchend", () => this.handleOnEnd());
  }
  private addSlider() {
    this.Slider = new Slider({
      bg: this.generateBar(),
      fill: this.generateBar(true),
      slider: this.generateSliderButton(),
      min: 0,
      max: 200,
      value: 100,
    });
    this.addChild(this.Slider);
    this.Slider.onUpdate.connect((value) => {
      this.handleOnUpdate(value);
    });
  }
}